import axios from 'axios';
import { push } from 'react-router-redux';
export const FETCH_VIP_INFO = 'vip/FETCH_VIP_INFO';
export const FETCH_VIP_INFO_DONE = 'vip/FETCH_VIP_INFO_DONE';
export const ACTIVE_VIP = 'vip/ACTIVE_VIP';
export const ACTIVE_VIP_DONE = 'vip/ACTIVE_VIP_DONE';
export const CHECK_VIP_PRELIMINARY = 'vip/CHECK_VIP_PRELIMINARY';

axios.defaults.withCredentials = true;

const initialState = {
    loading: true,
    checking: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CHECK_VIP_PRELIMINARY:
            return { ...state, checking: true };
        case FETCH_VIP_INFO:
            return { ...state, loading: true }
        case FETCH_VIP_INFO_DONE:
            return {
                ...state,
                ...action.state,
                loading: false,
                checking: false
            };
        case ACTIVE_VIP:
            return { ...state, loading: true };
        case ACTIVE_VIP_DONE:
            return {
                ...state,
                ...action.state,
                loading: false
            };
        default:
            return state
    }
}

export const activeVip = () => {
    return dispatch => {
        dispatch({
            type: ACTIVE_VIP
        });
        return axios.get('/api/activeVip').then(response => {
            if (response.data.code === 1) {
                dispatch({ type: FETCH_VIP_INFO });
                return fetchVip().then(userInfo => {
                    dispatch({ type: FETCH_VIP_INFO_DONE, state: userInfo });
                });
            } else {
                dispatch(push('/error'));
            }
        });
    }
}

export const checkVipPreliminary = () => {
    return dispatch => {
        dispatch({
            type: CHECK_VIP_PRELIMINARY
        });
        return fetchVip().then(userInfo => {
            dispatch({ type: FETCH_VIP_INFO_DONE, state: userInfo });
        });
    }
}

export const fetchVipInfo = () => {
    return dispatch => {
        dispatch({
            type: FETCH_VIP_INFO
        });
        return fetchVip().then(userInfo => {
            dispatch({ type: FETCH_VIP_INFO_DONE, state: userInfo });
        });
    }
}

function fetchVip() {
    return axios('/api/fetchVipInfo').then(response => {
        if (response.data.code === 1) {
            const vip = response.data.vip || { status: 0, startTime: '', endTime: '' };
            return {
                internalId: response.data.account,
                pubpoints: response.data.pubPoints, // Pub點數
                orderAmount: response.data.sumAmount,          // 至今累計儲值金額
                vipStatus: vip.status, // vip狀態(未啟動/啟動)
                startTime: vip.startTime,     // vip起始時間
                endTime: vip.endTime,       // vip有效時間
                vipCardLevel: response.data.vipCard.level,  // vip符合資格卡別
                isBinding: response.data.isBinding,      // 是否綁定Pubgame帳號
                profileValid: response.data.profileValid,   // 是否完善個人資料
                phoneValid: response.data.phoneValid,     // 手機是否驗證過
                emailValid: response.data.emailValid,     // email是否驗證過
            };
        }
    });
}


// WEBPACK FOOTER //
// ./src/reducer/vip.js